<template>
  <div class="login-menu">
    <div v-if="loading">
      <div v-if="!finished" class="loading"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>
      <div v-else="">
        <span class="alert alert-success">
          <i class="fa fa-check"></i>
          <span class="help is-success">{{mensaje_ok}}</span>
        </span>

      </div>
    </div>
     <form v-show="!recover_password && !loading" @submit.prevent="validarLogin" data-vv-scope="loginform">
       <span v-show="mensaje_ok != ''" class="alert alert-success">
         <i class="fa fa-check"></i>
         <span class="help is-success">{{mensaje_ok}}</span>
       </span>

       <div class="column is-12 ">
           <label class="label">Email</label>
           <p class="control has-icon has-icon-right">
               <input name="email" v-model="email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('loginform.email') }" type="text" >
               <span v-show="errors.has('loginform.email')" class="alert alert-danger">
                 <i class="fa fa-exclamation-triangle"></i>
                 <span class="help is-danger">{{ errors.first('loginform.email') }}</span>
               </span>
           </p>
       </div>
       <div class="column is-12">
           <label class="label">Contraseña</label>
           <p class="control has-icon has-icon-right">
               <input name="password" v-model="password" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('loginform.password') }" type="password" >
               <span v-show="errors.has('loginform.password')" class="alert alert-danger">
                 <i class="fa fa-exclamation-triangle"></i>
                 <span class="help is-danger">{{ errors.first('loginform.password') }}</span>
               </span>
               <span v-show="mensaje_error != ''" class="alert alert-danger">
                 <i class="fa fa-exclamation-triangle"></i>
                 <span class="help is-danger">{{mensaje_error}}</span>
               </span>
            </p>
        </div>
      <div class="column is-12 row">
              <div class="col-6" style="text-align:right;width:50%;margin-right:0px;padding-right:0px;">
               <span style="margin-right:10px;" v-if="!recover_password" class="btn-recover-password" @click="recover_password = true; mensaje_error = ''">
                 <a href="#"><span style="font-size:13px;">Recuperar contraseña </span></a>
              </span>
            </div>
            <div class="col-6" style="text-align:left;width:50%;position:relative;float:left;margin-left:0px;padding-left:0px;">
              <span style="border-left: 1px solid #000;margin-left:0px;padding-left:5px">
                <a href="/registro"><span style="font-size:13px;"> Regístrate</span></a>
              </span>
            </div>
       </div>
       <div class="column is-12">
           <input name="submit" type="submit" class="btn" value="Acceder">
       </div>

    </form>

    <span v-if="recover_password" class="btn-volver" @click="recover_password = false; mensaje_error = ''"><span><i class="fa fa-chevron-left"></i>Volver</span></span>
    <form v-show="recover_password && !loading" @submit.prevent="validarRecuperarContrasena" data-vv-scope="passwordform">
      <div class="column is-12 ">
          <label class="label">Email</label>
          <p class="control has-icon has-icon-right">
              <input name="email" v-model="email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('passwordform.email') }" type="text" >
              <span v-show="errors.has('passwordform.email')" class="alert alert-danger">
                <i class="fa fa-exclamation-triangle"></i>
                <span class="help is-danger">{{ errors.first('passwordform.email') }}</span>
              </span>
              <span v-show="mensaje_error != ''" class="alert alert-danger">
                <i class="fa fa-exclamation-triangle"></i>
                <span class="help is-danger">{{mensaje_error}}</span>
              </span>
          </p>
      </div>
      <div class="column is-12">
          <input name="submit" type="submit" class="btn" value="Recuperar contraseña">
      </div>

   </form>
  </div>
</template>
<script type='text/javascript' src='http://ajax.googleapis.com/ajax/libs/jquery/1.3.2/jquery.min.js'></script>
<script src="https://cdn.jsdelivr.net/npm/vue-resource@1.3.5"></script>
<script>
var axios = require('axios')
// Load the full build.
// var _ = require('lodash');
// var debounce = require('lodash/debounce');

export default {
  name: 'PeticionForm',
  data () {
    return {
      recover_password: false,
      email: '',
      password: '',
      hash: '',
      loading: false,
      finished: false,
      mensaje_error: '',
      mensaje_ok: '',
      url: ''
    }
  },
  methods: {
    resetForm () {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    validarLogin: function (event) {
      this.mensaje_error = ''
      this.mensaje_ok = ''
      this.$validator.validateAll('loginform').then((result) => {
        if (result) {
          this.loading = true
          // eslint-disable-next-line
          var that = this;
          var data = {
            usuario: that.email,
            password: that.password
          }

          // axios.post('/acceso', data, { crossdomain: true }).then(function (response) {
          //   that.finished = true
          //   if (response.data.success === false) {
          //     that.loading = false
          //     that.mensaje_error = 'Usuario o contraseña incorrectos'
          //   } else {
          //     that.mensaje_ok = 'Login correcto. Redirigiendo...'
          //     window.location.replace('/admin/escritorio')
          //   }
          //
          // //  alert("OK:"+JSON.stringify(data));
          // }).catch(function (error) {
          //   alert('Error:' + JSON.stringify(error))
          this.mensaje_error = ''
          that.loading = true
          var respuesta='';
          //var setHeader = {'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*'}
          (function($) {
          $.ajax({
            async: false,
            type: 'POST',
            // url: 'http://localhost/dsimobility/vuejs/prueba/src/components/login.php',
            url: that.url+'/wp-content/themes/Avada-Child-Theme/peticion/lib/login.php',
            data: {email: data.usuario, contrasenya:data.password},
            crossDomain: true,
            dataType: 'json',
            //headers: setHeader,
            success: function(data){
              // console.log(data)
              // console.log('En el success')
                if(data.status == 200){
                  that.loading = false;
                  if(data.data.status == 200)
                  {
                      that.mensaje_ok='Datos correctos. Estamos redirigiendo...'
                      that.hash=data.data.hash
                      sessionStorage.setItem('h', true);
                      var datos={
                          email: data.usuario,
                          hash: data.data.hash,
                          contrasenya: data.password
                      }
                      //console.log(datos);
                       // window.localStorage.setItem('auth_token',data.data.hash);
                       // document.cookie='token='+data.data.hash+' path=https://yonderauto.com';
                        var url= 'https://intranet.dsimobility.es/admin/escritorio';
                       // window.location.hash=data.data.hash;
                      // window.location.replace(url);
                      //this.window.location(url);

                      // header('Location: https://yonderauto.com/admin/escritorio')
                      // exit
                      that.accesoweb(that);
                  }else{
                      that.mensaje_error=data.data.msg
                  }
                }
                else{
                  that.loading = false;
                  that.mensaje_error=data.data.msg;
                }
            }
          })
          })(jQuery);

          setTimeout(function () { }, 2000)
          // return
        }
        // alert('Correct them errors!');
      })
      //  this.validaMatricula(that);
    },
    accesoweb: function (event) {
      var data = {
        usuario: this.email,
        password: this.password,
        hash: this.hash
      };
      var that=this;
      // var setHeader = {
      //   'Access-Control-Allow-Headers': '*',
      //    'Access-Control-Allow-Origin': 'origin-list',
      //    'Accept': 'text/html',//'application/json',
      //    'Authorization': 'Bearer ' + data.hash
      // }
      (function($) {
      $.ajax({
        async: false,
        type: 'POST',
        //url: 'http://localhost/dsimobility/vuejs/prueba/src/components/acceso.php',
        url: that.url+'/wp-content/themes/Avada-Child-Theme/peticion/lib/acceso.php',
        data: {email: data.usuario, contrasenya:data.password},
        crossDomain: true,
        dataType: 'json',
        //headers: setHeader,
        success: function(data){
            if(data.status == 200){
              // that.loading = false;
              if(data.data.status == 200)
              {
                  var url= 'https://intranet.dsimobility.es/admin/escritorio?s='+data.data.codif;
                  window.location.replace(url);
              }else{
                  this.mensaje_error=data.data.msg;
              }
            }
            else{
              this.loading = false;
              this.mensaje_error=data.data.msg;
            }
        },
        error: function (textStatus, errorThrown) {
            var success = false;//doesn't go here
            return success;
        }
      })
      })(jQuery);
    },
    validarRecuperarContrasena: function (event) {
      this.mensaje_error = ''
      this.mensaje_ok = ''
      this.$validator.validateAll('passwordform').then((result) => {
        if (result) {
          this.loading = true
          // eslint-disable-next-line
          var that = this
          var data = {
            email: that.email,
            url: that.url
          }
          if(that.recover_password == true)
          {
          //axios.post('/datos-acceso', data, { crossdomain: true }).then(function (response) {
          (function($) {
          $.ajax({
            async: false,
            type: 'POST',
            //url: 'http://localhost/dsimobility/vuejs/prueba/src/components/lib/recuperarpass.php',
            url: that.url+'/wp-content/themes/Avada-Child-Theme/peticion/lib/recuperarpass.php',
            data: {email: data.email, url: data.url},
            crossDomain: true,
            dataType: 'json',
            //headers: setHeader,
            success: function(response){
              if (response.data.success === false) {
                that.loading = false
                that.mensaje_error = 'Email incorrecto'
                that.finished = false
              } else {
                that.mensaje_ok = 'En breve recibiras un e-mail con tu contraseña.'
                that.finished = false
                that.loading = false
                that.recover_password = false
                //  window.location.replace("/admin/escritorio");
              }
            },
            error: function (error) {
              alert('Error:' + JSON.stringify(error))
                that.mensaje_error = 'Error Interno'
                that.finished = false
                that.loading = false
                // console.log(error.message);
            }
            // var data = {
            //   email:that.email,
            //   password:that.password,
            //   recordarme:1
            // };

          //  alert("OK:"+JSON.stringify(data));
          // }).catch(function (error) {
          //   alert('Error:' + JSON.stringify(error))
          //   that.mensaje_error = 'Error Interno'
          //   that.finished = false
          //   that.loading = false
          //   // console.log(error.message);
        })
        })(jQuery);
      }else{
        that.mensaje_error = 'Contraseña ya enviada'
      }
          //setTimeout(function () { }, 2000)
          // return
        }

        // alert('Correct them errors!');
      })

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue